import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TEST_CONFIG_SERVICE } from '@eggplant/api-hosts'
import type { BaseCustomScript } from '@eggplant/types'
import type { ReactElement } from 'react'

export interface Props {
  id: string
  children: (data: BaseCustomScript) => ReactElement
  onSuccess: (data: BaseCustomScript) => void
}

const GetCustomScriptRequest = ({
  id,
  onSuccess,
  children
}: Props) => {
  const url = TEST_CONFIG_SERVICE + '/custom_scripts/' + id

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetCustomScriptRequest
